"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var formActions_1 = require("../../actions/formActions");

var set_1 = __importDefault(require("lodash/set"));

var initialState = {};

var recordReducer = function recordReducer(previousState, action) {
  if (previousState === void 0) {
    previousState = initialState;
  }

  if (action.type === formActions_1.RESET_FORM) {
    return initialState;
  }

  if (action.type === formActions_1.INITIALIZE_FORM) {
    return Object.keys(action.payload).reduce(function (acc, key) {
      // Ensure we correctly set default values for path with dot notation
      set_1.default(acc, key, action.payload[key]);
      return acc;
    }, __assign({}, previousState));
  }

  return previousState;
};

exports.default = recordReducer;